import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Authentication/Login";
import Flights from "./Components/Flight/Flights";
import SearchFlight from "./Components/Flight/SearchFlight";
import CompanyProfile from "./Components/Master/CompanyProfile";
import Branch from "./Components/Master/Branch";
import Supplier from "./Components/Master/Supplier";
import LeadStatus from "./Components/Marketing/LeadStatus";
import Users from "./Components/Master/Users";
import FlightDetails from "./Components/Flight/FlightDetails";
import DestinationType from "./Components/Master/DestinationType";
import Destination from "./Components/Master/Destination";
import TravelType from "./Components/Master/TravelType";
import PackageComponent from "./Components/Package/CreatePackage";
import PackageList from "./Components/Package/PackageList";
import Marketing from "./Components/Marketing/Marketing";
import ReviewFlight from "./Components/Flight/ReviewFlight";
import Customer from "./Components/Master/Customer";
import Source from "./Components/Marketing/Source";
import Lead from "./Components/Marketing/Lead";
import LeadCalendar from "./Components/Marketing/LeadCalendar";
import Umrah from "./Components/Umrah/CreateUmrah";
import UmrahList from "./Components/Umrah/UmrahList";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightVoucher from "./Components/Flight/FlightVoucher";
import SearchHotel from "./Components/Hotels/SearchHotels";
import HotelsList from "./Components/Hotels/HotelsList";
import FlightInvoice from "./Components/Flight/FlightInvoice";
import SightSeeingSearch from "./Components/SightSeeing/SightSeeingSearch";
import SightSeeingProducts from "./Components/SightSeeing/SightSeeingProducts";
import SightSeeingProduct from "./Components/SightSeeing/SightSeeingProduct";
import HotelDetails from "./Components/Hotels/HotelDetails";
import PackageDate from "./Components/Package/PackageDate";
import HotelGuests from "./Components/Hotels/HotelGuests";
import EnquiryList from "./Components/Package/EnquiryList";
import LandingPage from "./Components/Settings/LandingPage";
import HotelReview from "./Components/Hotels/HotelReview";
import HotelBookings from "./Components/Hotels/HotelBookings";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails";
import HotelVoucher from "./Components/Hotels/HotelVoucher";
import HotelInvoice from "./Components/Hotels/HotelInvoice";
import FromOrigin from "./Components/Package/FromOrigin";
import GroupBookings from "./Components/Flight/GroupBookings";
import Dashboard from "./Components/Dashboard/Dashboard";
import Hajj from "./Components/Hajj/CreateHajj";
import HajjList from "./Components/Hajj/HajjList";
import HajjEnquiry from "./Components/Hajj/HajjEnquiry";
import UmrahEnquiryList from "./Components/Umrah/UmrahEnquiryList";
import FlightReport from "./Components/Report/FlightReport";
import HotelReport from "./Components/Report/HotelReport";
import GstReport from "./Components/Report/GstReport";
import AgentPayments from "./Components/Companies/AgentPayments";
import AgentCredits from "./Components/Companies/AgentCredits";
import AgentInvoice from "./Components/Companies/AgentInvoice";
import SightSeeingBooking from "./Components/SightSeeing/SightSeeingBooking";
import SightSeeingBookingDetails from "./Components/SightSeeing/SightSeeingBookingDetails";
import ChangePassword from "./Components/Master/ChangePassword";
import AIPackageComponent from "./Components/AIPackage/CreatePackage";
import PackageTemplates from "./Components/Package/PackageTemplates";
import SearchVisas from "./Components/Visas/Visas";
import Promotions from "./Components/Marketing/Promotions.jsx";
import LeadManagementDashboard from "./Components/Marketing/LeadDashboard.jsx";
import AISupplierPackageComponent from "./Components/SupplierAi/CreateSupplierPackage.jsx";
import WebsitePackageList from "./Components/Package/WebsitePackageList.jsx";
import LeadReports from "./Components/Marketing/LeadReports.jsx";
import CreditHistory from "./Components/Master/CreditHistory.jsx";
import VisaRequestReports from "./Components/Visas/VisaRequestReport.jsx";
import VisaSupplierReports from "./Components/Visas/VisaSupplierReport.jsx";
import SaasRegister from "./Authentication/SaasRegistration.jsx";
import ForgotPassword from "./Authentication/ForgotPassword.jsx";
import SubscriptionPlan from "./Components/Companies/SubscriptionPlan.jsx";
import WebsiteUmrahList from "./Components/Umrah/WebsiteUmrahList.jsx";
import WebsiteHajjList from "./Components/Hajj/WebsiteHajjList.jsx";
import ConfirmEmail from "./Authentication/ConfirmEmail.jsx";
import TaxInformation from "./Authentication/TaxInformation.jsx";
import RegistrationPending from "./Authentication/RegistrationPending.jsx";
import ChatBotSettings from "./Components/ChatBot/ChatBotSettings.jsx";

import WhatsAppCallback from "./Components/ChatBot/WhatsAppCallback.jsx";
import SupplierRegister from "./Authentication/SupplierRegistration.jsx";
import DMCRegistration from "./Authentication/DMCRegistration.jsx";
import VisaProviders from "./Authentication/VisaProviders.jsx";
import SupplierTaxInformation from "./Supplier/SupplierTaxInformation.jsx";
import SupplierVisaPrices from "./Supplier/SupplierVisaPrices.jsx";
import SupplierVisaRequests from "./Supplier/SupplierVisaRequests.jsx";
import SightSeeingBookings from "./Components/SightSeeing/SightSeeingBookings.jsx";
import ResetPassword from "./Authentication/ResetPassword.jsx";
import AboutPage from "./StaticPages/AboutPage.jsx";
import FeaturesPage from "./StaticPages/FeaturesPage.jsx";
import BlogPage from "./StaticPages/BlogPage.jsx";
import ContactPage from "./StaticPages/ContactPage.jsx";
import PrivacyPolicy from "./StaticPages/PrivacyPolicy.jsx";
import Terms from "./StaticPages/Terms.jsx";
import PublicLayout from "./Common/Layout/PublicLayout.jsx";
import AppLayout from "./Common/Layout/AppLayout.jsx";
import MySubscriptionPlan from "./Components/Master/MySubscriptionPlan.jsx";
import VisaAppointments from "./Supplier/VisaAppointments.jsx";
import VisaAppointmentCalendar from "./Components/Visas/VisaAppointmentCalendar.jsx";
import Visas from "./Components/Visas/Visas.jsx";
import RequestDetails from "./Components/Visas/RequestDetails.jsx";
import Requests from "./Components/Visas/Requests.jsx";
import BusSearch from "./Components/Bus/SearchBus.jsx";
import BusResults from "./Components/Bus/BusResults.jsx";
import CompanyBankAccounts from "./Components/Companies/CompanyBankAccounts.jsx";
import Holiday from "./Components/Holiday/Holiday.jsx";
import HolidayFlightPackage from "./Components/Holiday/HolidayFlightPackage.jsx";
import HolidayLandPackage from "./Components/Holiday/HolidayLandPackage.jsx";
import ManualPackageForm from "./Components/Holiday/ManualPackageForm.jsx";
import TopUpHistory from "./Components/Master/TopUpHistory.jsx";
import TopUpRequest from "./Components/Master/TopUpRequest.jsx";
import FlightSupplierReport from "./Components/Report/FlightSupplierReport.jsx";
import HolidayComponent from "./Components/Holiday/CreateHoliday.jsx";
import HolidayTemplatePreviewPage from "./Components/Holiday/HolidayTemplatePreviewPage.jsx";
import BookingDetails from "./Components/Bus/BookingDetails.jsx";
import BusPayment from "./Components/Bus/BusPayment.jsx";
import BusBookingConfirmation from "./Components/Bus/BusBookingConfirmation.jsx";
import BusBookings from "./Components/Bus/BusBookings.jsx";
import BusSeatSelection from "./Components/Bus/BusSeatSelection.jsx";
import SupplierDashboard from "./Components/Dashboard/SupplierDashboard.jsx";
import VisaDashboard from "./Supplier/VisaDashboard.jsx";
import HolidayDashboard from "./Supplier/HolidayDashboard.jsx";
import HolidayList from "./Components/Holiday/HolidayList.jsx";
import SaleInvoice from "./Components/Accounts/Invoices/SaleInvoice.jsx";
import EditSaleInvoice from "./Components/Accounts/Invoices/EditSaleInvoice";
import SaleView from "./Components/Accounts/Invoices/SaleView";
import SaleList from "./Components/Accounts/Invoices/SaleList";
import PurchaseInvoice from "./Components/Accounts/Invoices/PurchaseInvoice";
import PurchaseList from "./Components/Accounts/Invoices/PurchaseList";
import EditPurchaseInvoice from "./Components/Accounts/Invoices/EditPurchaseInvoice";
import PurchaseView from "./Components/Accounts/Invoices/PurchaseView";
import ExpenseInvoice from "./Components/Accounts/Invoices/ExpenseInvoice";
import ExpenseList from "./Components/Accounts/Invoices/ExpenseList";
import ExpenseView from "./Components/Accounts/Invoices/ExpenseView";
import EditExpenseInvoice from "./Components/Accounts/Invoices/EditExpenseInvoice";
import ExpenseReport from "./Components/Accounts/Reports/ExpenseReport";
import SalesReport from "./Components/Accounts/Reports/SalesReport";
import PurchasesReport from "./Components/Accounts/Reports/PurchasesReport";
import InvoiceReport from "./Components/Accounts/Reports/InvoiceReport";
import Cheque from "./Components/Accounts/Reports/Cheque";
import CompletePayment from "./Components/Bus/CompletePayment.jsx";
import BlockedSeatsConfirmation from "./Components/Bus/BlockedSeatsConfirmation.jsx";
import MarkupSetting from "./Components/Master/MarkupSetting.jsx";
import DMCPackageCreator from "./DMC/DMCPackage/DMCPackageCreate.jsx";
import DMCPackageList from "./DMC/DMCPackage/DMCPackagesList.jsx";
import DMCPackageDetails from "./DMC/DMCPackage/DMCPackageDetails.jsx";
import DMCDealsList from "./DMC/DMCPackage/DMCDeals.jsx";
import AccountDashboard from "./Components/Dashboard/AccountDashboard.jsx";
import SeriesFares from "./Components/SeriesFare/SeriesFare.jsx";
import SeriesFareAgentSearch from "./Components/SeriesFare/AgentSearch.jsx";
import SeriesFarePayment from "./Components/SeriesFare/SeriesFarePayment.jsx";
import SeriesFareBlockConfirmation from "./Components/SeriesFare/SeriesFareBlockConfirmation.jsx";
import AgentBookings from "./Components/SeriesFare/AgentBookings.jsx";
import DmcBlockRequests from "./Components/SeriesFare/DmcBlockRequests.jsx";
import DMCPackageEnquiry from "./DMC/DMCPackage/DMCPackageEnquiry.jsx";
import DMCPackagePDFCreator from "./DMC/DMCPackage/DMCPackagePDFCreator.jsx";
import SeriesFareDashboard from "./Supplier/SeriesFares/SeriesFareDashboard.jsx";
import SeriesFareList from "./Components/SeriesFare/SeriesFareList.jsx";
import BookingAccounting from "./Components/MongoAccounts/BookingAccounting.jsx";
import ProfitLossReport from "./Components/MongoAccounts/ProfitLossReport.jsx";
import ProfitLossDetailedReport from "./Components/MongoAccounts/ProfitLossDetailedReport.jsx";
import DMCList from "./DMC/DMCList.jsx";
import StatementOfAccount from "./Components/MongoAccounts/StatementOfAccount.jsx";
import SupplierLedger from "./Components/MongoAccounts/SupplierLedger.jsx";
import AgentLedger from "./Components/MongoAccounts/AgentLedger.jsx";
import MongoAccountingDashboard from "./Components/MongoAccounts/MongoAccountingDashboard.jsx";
import HotelsMasterSearch from "./DMC/HotelDmc/HotelsMasterSearch.jsx";
import BookingEnquiries from "./DMC/HotelDmc/BookingEnquiries.jsx";
import HotelDashboard from "./DMC/HotelDmc/HotelDashboard.jsx";
import ManualVoucherGenerator from "./Components/Flight/ManualVoucherGenerator.jsx";
import PublicFaq from "./Common/Layout/PublicFaq.jsx";
import AgentWebsiteShowcase from "./Website/AgentWebsiteShowcase.jsx";
import HotelDMCProperties from "./DMC/HotelDmc/HotelDMCProperties.jsx";
import PropertiesList from "./DMC/HotelDmc/PropertiesList.jsx";
import TBOSupplierHighlight from "./SuppliersInfo/TboInfo.jsx";
import TripjackSupplierHighlight from "./SuppliersInfo/TripJackInfo.jsx";
import AkbarTravelsSupplierHighlight from "./SuppliersInfo/AkbarInfo.jsx";
import RezLiveSupplierHighlight from "./SuppliersInfo/RezLive.jsx";
import GRNConnectSupplierHighlight from "./SuppliersInfo/GRNInfo";
import RiyaTravelSupplierHighlight from "./SuppliersInfo/Riya.jsx";
import ViatorSupplierHighlight from "./SuppliersInfo/ViatorInfo.jsx";
import AirIQSupplierHighlight from "./SuppliersInfo/AirIQInfo.jsx";
import DmcEnquiryList from "./DMC/DMCPackage/DmcEnquiryList.jsx";
import Employee from "./Components/Master/Employee.js";


import TeamOutingRequest from "./Components/CorporateB2EScreens/TeamOutingRequest.jsx";
import GroupTourAdmin from "./Components/CorporateB2EScreens/GroupTourRequest.jsx";
import CompanyAgents from "./Components/Master/Agents/CompanyAgents.jsx";
import AgentWallet from "./Components/Master/Agents/AgentWallet.jsx";
import DMCPackageDetailsForAgents from "./DMC/DMCPackage/DMCPackageDetailsForAgents.jsx";
import CompanyCorporate from "./Components/Master/Agents/CompanyCorporate.jsx";
import CorporateWallet from "./Components/Master/Agents/CorporateWallet.jsx";



function App() {
  return (
    <>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<SaasRegister />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/supplierregister" element={<SupplierRegister />} />
          <Route path="/dmcregister" element={<DMCRegistration />} />
          <Route path="/visaregister" element={<VisaProviders />} />
          <Route path="/faq" element={<PublicFaq />} />
          <Route
            path="/suppliertaxinformation"
            element={<SupplierTaxInformation />}
          />
          <Route path="/tax-information" element={<TaxInformation />} />
          <Route
            path="/registration-pending"
            element={<RegistrationPending />}
          />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />

          {/* supplier information  */}
          <Route path="/supplier/trip-jack" element={<TripjackSupplierHighlight />} />
          <Route path="/supplier/tbo" element={<TBOSupplierHighlight />} />
          <Route path="/supplier/akbar-travels" element={<AkbarTravelsSupplierHighlight />} />
          <Route path="/supplier/rezlive" element={<RezLiveSupplierHighlight />} />
          <Route path="/supplier/grn-connect" element={<GRNConnectSupplierHighlight />} />
          <Route path="/supplier/riya-travel" element={<RiyaTravelSupplierHighlight />} />
          <Route path="/supplier/viator" element={<ViatorSupplierHighlight />} />

          <Route path="/supplier/air-iq" element={<AirIQSupplierHighlight />} />

        </Route>

        <Route element={<AppLayout />}>
          <Route path="/flight/search" element={<SearchFlight />} />
          <Route path="/hotel/search" element={<SearchHotel />} />
          <Route path="/sightseeing/search" element={<SightSeeingSearch />} />
          <Route path="/umrah" element={<Umrah />} />
          <Route path="/packageslist" element={<PackageList />} />
          <Route path="/hajjList" element={<HajjList />} />

          <Route path="/login" element={<Login />} />

          <Route path="/subscriptionplans" element={<SubscriptionPlan />} />
          <Route path="/myplan" element={<MySubscriptionPlan />} />
        

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/companyprofile" element={<CompanyProfile />} />

          <Route path="/branchs" element={<Branch />} />
          <Route path="/users" element={<Users />} />
          
          <Route path="/employee" element={<Employee />} />
          <Route
            path="/companybankaccounts"
            element={<CompanyBankAccounts />}
          />
         
          <Route path="/leadstatus" element={<LeadStatus />} />
          <Route path="/source" element={<Source />} />
          <Route path="/leads" element={<Lead />} />
          <Route path="/leaddashboard" element={<LeadManagementDashboard />} />
          <Route path="/leadreports" element={<LeadReports />} />
          <Route path="/suppliers" element={<Supplier />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/promotion" element={<Promotions />} />

          <Route
            path="/flights/:adults?/:kids?/:infants?/:isDomestic?"
            element={<Flights />}
          />
          <Route
            path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?"
            element={<FlightDetails />}
          />
          <Route
            path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?"
            element={<ReviewFlight />}
          />
          <Route path="/flight/bookings" element={<FlightBookings />} />
          <Route
            path="/flight/booking/:flightBookingId"
            element={<FlightBookingDetails />}
          />
          <Route
            path="/flight/voucher/:flightBookingId"
            element={<FlightVoucher />}
          />
          <Route
            path="/flight/invoice/:flightBookingId"
            element={<FlightInvoice />}
          />

          <Route
            path="/flight/supplierreport"
            element={<FlightSupplierReport />}
          />

          <Route path="/hotels" element={<HotelsList />} />
          <Route path="/hotel/details" element={<HotelDetails />} />
          <Route path="/hotel/guests" element={<HotelGuests />} />
          <Route path="/hotel/review" element={<HotelReview />} />
          <Route path="/hotel/bookings" element={<HotelBookings />} />
          <Route
            path="/hotel/booking/:hotelBookingId"
            element={<HotelBookingDetails />}
          />
          <Route
            path="/hotel/voucher/:hotelBookingId"
            element={<HotelVoucher />}
          />
          <Route
            path="/hotel/invoice/:hotelBookingId"
            element={<HotelInvoice />}
          />

          <Route
            path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate"
            element={<SightSeeingProducts />}
          />
          <Route
            path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate"
            element={<SightSeeingProduct />}
          />
          <Route
            path="/sightseeing/booking/:productId/:destinationCode/:destination/:adults?/:kids?/:infants?/:travelDate"
            element={<SightSeeingBooking />}
          />
          <Route
            path="/sightseeing/booking/:sightSeeingBookingId"
            element={<SightSeeingBookingDetails />}
          />
          <Route
            path="/sightseeing/bookings"
            element={<SightSeeingBookings />}
          />
          <Route path="/destinationtypes" element={<DestinationType />} />
          <Route path="/destinations" element={<Destination />} />
          <Route path="/traveltypes" element={<TravelType />} />
          <Route path="/package/:packageId?" element={<PackageComponent />} />
          <Route
            path="/packagedetails/:packageId"
            element={<PackageTemplates />}
          />
          <Route path="/websitepackages" element={<WebsitePackageList />} />
          <Route path="/websiteumrahpackages" element={<WebsiteUmrahList />} />
          <Route path="/websitehajjpackages" element={<WebsiteHajjList />} />

          <Route
            path="/aipackage/:packageId?"
            element={<AIPackageComponent />}
          />
          <Route
            path="/aisupplierpackage/:packageId?"
            element={<AISupplierPackageComponent />}
          />

          <Route path="/marketing" element={<Marketing />} />
          <Route path="/customers" element={<Customer />} />
          <Route path="/leadcalendar" element={<LeadCalendar />} />

          <Route path="/packagedates" element={<PackageDate />} />
          <Route path="/orign" element={<FromOrigin />} />
          <Route path="/enquirylist" element={<EnquiryList />} />

          <Route path="/landingpage" element={<LandingPage />} />
          <Route path="/groupbookings" element={<GroupBookings />} />

          <Route path="/umrahList" element={<UmrahList />} />
          <Route path="/umrahpackage/:packageId?" element={<Umrah />} />
          <Route path="/umrahenquiry" element={<UmrahEnquiryList />} />

          <Route path="/hajjpackage/:packageId?" element={<Hajj />} />
          <Route path="/hajj" element={<Hajj />} />

          <Route path="/hajjenquiry" element={<HajjEnquiry />} />

          <Route path="/flightreport" element={<FlightReport />} />
          <Route
            path="/flightsupplierreport"
            element={<FlightSupplierReport />}
          />
          <Route path="/hotelreport" element={<HotelReport />} />
          <Route path="/gstreport" element={<GstReport />} />

          
          <Route path="/agent/payments" element={<AgentPayments />} />
          <Route path="/agent/credits" element={<AgentCredits />} />
          <Route path="/agent/invoices" element={<AgentInvoice />} />

          <Route path="/visarequestreport" element={<VisaRequestReports />} />
          <Route path="/visasupplierreport" element={<VisaSupplierReports />} />

          <Route path="/supplier/visaprices" element={<SupplierVisaPrices />} />
          <Route
            path="/supplier/visarequests"
            element={<SupplierVisaRequests />}
          />
          <Route
            path="/supplier/visaappointments"
            element={<VisaAppointments />}
          />

       
          <Route
            path="visaappointments"
            element={<VisaAppointmentCalendar />}
          />

          <Route path="/credithistory" element={<CreditHistory />} />
          <Route path="/topuphistory" element={<TopUpHistory />} />
          <Route path="/topuprequest" element={<TopUpRequest />} />
          <Route path="/chatbot" element={<ChatBotSettings />} />
          <Route path="/whatsapp-callback" element={<WhatsAppCallback />} />

         

          <Route path="/visas" element={<Visas />} />
          <Route path="/request/:visaRequestId" element={<RequestDetails />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/bus/search" element={<BusSearch />} />
          <Route path="/bus/results" element={<BusResults />} />
          <Route path="/bus/seats" element={<BusSeatSelection />} />
          <Route path="/bus/payment" element={<BusPayment />} />
          <Route
            path="/bus/booking-confirmation"
            element={<BusBookingConfirmation />}
          />
          <Route path="/bus/bookings" element={<BusBookings />} />
          <Route path="/bus/booking/:bookingId" element={<BookingDetails />} />
          <Route path="/bus/completepayment" element={<CompletePayment />} />
          <Route
            path="/bus/blocked-confirmation"
            element={<BlockedSeatsConfirmation />}
          />

          <Route path="/holiday" element={<Holiday />} />
          <Route
            path="/holidayflightpackage"
            element={<HolidayFlightPackage />}
          />
          <Route path="/holidaylandpackage" element={<HolidayLandPackage />} />
          <Route path="/holidaymanualpackage" element={<ManualPackageForm />} />
          <Route path="/holiday/create" element={<HolidayComponent />} />
          <Route path="/holiday/:packageId" element={<HolidayComponent />} />

          <Route path="/ai-packageslist" element={<HolidayList />} />
  
          <Route path="/supplierdashboard" element={<SupplierDashboard />} />

          <Route path="/visadashboard" element={<VisaDashboard />} />
          <Route path="/holidaydashboard" element={<HolidayDashboard />} />


          

          <Route path="/saleinvoice" element={<SaleInvoice />} />
          <Route
            path="/editsaleinvoice/:invoiceId"
            element={<EditSaleInvoice />}
          />
          <Route path="/sale/view/:invoiceId" element={<SaleView />} />
          <Route path="/salelist" element={<SaleList />} />

          <Route path="/purchaseinvoice" element={<PurchaseInvoice />} />
          <Route path="purchaselist" element={<PurchaseList />} />
          <Route path="/purchase/view/:invoiceId" element={<PurchaseView />} />
          <Route
            path="/editpurchaseinvoice/:invoiceId"
            element={<EditPurchaseInvoice />}
          />
          <Route path="/expenseinvoice" element={<ExpenseInvoice />} />
          <Route path="expenselist" element={<ExpenseList />} />
          <Route path="/expense/view/:invoiceId" element={<ExpenseView />} />
          <Route
            path="/editexpenseinvoice/:invoiceId"
            element={<EditExpenseInvoice />}
          />
         
          <Route path="/expensesReport" element={<ExpenseReport />} />
          <Route path="/salesReport" element={<SalesReport />} />
          <Route path="/purchasesReport" element={<PurchasesReport />} />
          <Route path="/invoiceReport" element={<InvoiceReport />} />
          <Route path="/cheques" element={<Cheque />} />
          <Route path="/markup-setting" element={<MarkupSetting />} />
          <Route path="/dmcpackagecreate" element={<DMCPackageCreator />} />
          <Route path="/dmcpackageslist" element={<DMCPackageList />} />
          <Route path="/dmcpackageview/:id" element={<DMCPackageDetails />} />
          <Route path="/dmcpackagedetails/:id" element={<DMCPackageDetailsForAgents />} />
          <Route path="/dmcpackagesdeals" element={<DMCDealsList />} />
          <Route path="/dmcpackageenquiries" element={<DMCPackageEnquiry />} />
          <Route path="/dmccreate-pdf" element={<DMCPackagePDFCreator />} />
          <Route path="/accounts/dashboard" element={<AccountDashboard />} />
          <Route path="/seriesfare" element={<SeriesFares />} />
          <Route path="/seriesfare/agent-search" element={<SeriesFareAgentSearch />} />
          <Route path="/seriesfare/dashboard" element={<SeriesFareDashboard />} />
          <Route path="/seriesfarelist" element={<SeriesFareList />} />
          <Route path="/seriesfare-payment" element={<SeriesFarePayment />} />
          <Route path="/seriesfare/blockconfirmation" element={<SeriesFareBlockConfirmation />} />
          <Route path="/seriesfare/agentbookings" element={<AgentBookings />} />
          <Route path="/seriesfare/blockrequest" element={<DmcBlockRequests />} />
          <Route path="/team-outing-requests" element={<TeamOutingRequest/>} />
          <Route path="/group-tour-requests" element={<GroupTourAdmin />} />
          <Route path="/flight/booking-accounting/:bookingId" element={<BookingAccounting />} />
          <Route path="/profit-loss-report" element={<ProfitLossReport />} />
          <Route path="/profit-loss-detailedreport" element={<ProfitLossDetailedReport />} />
          <Route path="/dmc-list" element={<DMCList />} />
          <Route path="/seriesfarelist" element={<SeriesFareList />} />
          <Route path="/flight/booking-accounting/:bookingId" element={<BookingAccounting />} />
          <Route path="/profit-loss-report" element={<ProfitLossReport />} />
          <Route path="/profit-loss-detailedreport" element={<ProfitLossDetailedReport />} />
          <Route path="/dmc-list" element={<DMCList />} />
          <Route path="/statement-of-account" element={<StatementOfAccount />} />
          <Route path="/supplier-ledger" element={<SupplierLedger />} />
          <Route path="/agent-ledger" element={<AgentLedger />} />
          <Route path="/accounts-dashboard" element={<MongoAccountingDashboard />} />

          <Route path="/hotels/search" element={<HotelsMasterSearch />} />
          <Route path="/hotel/enquiries" element={<BookingEnquiries />} />
          <Route path="/hoteldashboard" element={<HotelDashboard />} />

          <Route path="/myproperties" element={<HotelDMCProperties />} />
          <Route path="/properties" element={<PropertiesList />} />

          <Route path="/tools/voucher-gen" element={<ManualVoucherGenerator />} />
          <Route path="/dmcpackageenquirylist" element={<DmcEnquiryList />} />
          
          <Route path="/agent-website-showcase" element={<AgentWebsiteShowcase />} />
       
 <Route path="/company/agents" element={<CompanyAgents/>} />
  <Route path="/agentwallet" element={<AgentWallet/>} />
  <Route path="/company/corporate" element={<CompanyCorporate/>} />
  <Route path="/corporatewallet" element={<CorporateWallet/>} />

  
  
         
        
        </Route>







  
        <Route path="/holiday-template-preview/:packageId/:templateId"element={<HolidayTemplatePreviewPage />}/>
        <Route path="/holidaydashboard" element={<HolidayDashboard />} />


    
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
